import styles from "./styles/Referral.module.css";
import "./styles/partnerPortal.css";
import data from "../../../data/multilanguage.json";
import { useMemo, useState } from "react";
import { ReactComponent as OkSvg } from "./styles/img/ok.svg";
import { PlusCircleOutlined } from "@ant-design/icons";
import { ReferralTable } from "./referralTable";
import TableFilter from "../Assets/TableFilter";

import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { submitCaptcha } from "../../../Utils/captcha";
import config from "../../../config";
import { getReferralData } from "../../../Utils/ReferralUtils";
import { Button, Skeleton, message } from "antd";
import { useEffect } from "react";
import { UserData } from "../../../Context/DataContext";
import dayjs from "dayjs";
import CampaignSection from "./campaginSection";
import ClaimRewards from "./claimRewardPopup";
import ActivateYourAccount from "./activateAccount";
import PendingModal from "./pendingModal";
import useWindowDimensions from "../../Footer/footer";
const base_url = config.base_url;

function PartnerPortalContent() {
  const userData = UserData();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const isFrench = useContext(LanguageContext).language.label === "fr";
  const currency = useContext(LanguageContext).currency;
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.ReferralContent
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const { width } = useWindowDimensions();

  const [referralData, setReferralData] = useState(UserData().referralData);
  //

  const [validated, setValidated] = useState(
    userData.userValidationData.validated
  );
  const [savedCampagins, setSavedCampagins] = useState([]);
  const [campaginNumber, setCampaginNumber] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [codeDeleted, setCodeDeleted] = useState(null);
  const [openValidateAccountPopup, setOpenValidateAccountPopup] =
    useState(false);
  const [pendingModal, setPendingModal] = useState(false);
  const onCancelPendingModal = () => {
    setPendingModal(false);
  };
  const [openClaimRewardPopup, setOpenClaimRewardPopup] = useState(false);
  const success = (text) => {
    messageApi.open({
      type: "success",
      content: text,
    });
  };
  const [filter, setFilter] = useState();
  const [referral, setReferral] = useState();
  const [ben, setBen] = useState();
  const [reward, setReward] = useState({});
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [loadingCamp, setLoadingCamp] = useState(true);
  const [totalEarned, setTotalEarned] = useState(0);
  useEffect(() => {
    if (reward) {
      /*
        `reward` starts as {}, so total_earned is undefined until
        /user/partner/stats answers -- and this effect runs before it does. The
        optional chain has to continue past total_earned, and `total` is NaN on
        that first pass, so toFixed needs guarding too. PartnerPortalContent,
        which this file is a copy of, already had both; this copy did not.
      */
      let total =
        reward?.total_earned?.money +
        reward?.total_unclaimed +
        reward?.total_pending;
      total = Number.isInteger(total) ? total : total?.toFixed(1);
      setTotalEarned(total);
    }
  }, [reward]);
  const onOkValidateAccount = () => {
    setOpenValidateAccountPopup(false);
  };
  const onCancelValidateAccount = () => {
    setOpenValidateAccountPopup(false);
  };
  const onOkClaimReward = () => {
    setOpenClaimRewardPopup(false);
  };
  const onCancelClaimReward = () => {
    setOpenClaimRewardPopup(false);
  };
  useEffect(() => {
    setValidated(userData.userValidationData.validated);
  }, [userData.userValidationData.validated]);

  useEffect(() => {
    if (!codeDeleted) return;
    success(dublicatedcontent.dublicatedText130);
  }, [codeDeleted]);

  useEffect(() => {
    fetch(base_url + "user/referral/info", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: ``,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.length === 0) {
          setCampaginNumber([
            {
              code: null,
              master: false,
              newCampaign: true,
              url: `${window?.location?.protocol}//${window?.location?.host}/register/?referral=YOUR CODE`,
            },
          ]);
          return;
        }
        setSavedCampagins(data);
        setCampaginNumber(data);
        setLoadingCamp(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingCamp(false);
      });
  }, []);
  useEffect(() => {
    fetch(base_url + "user/partner/stats", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: ``,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        setReward(res);
        setSkeletonLoading(false);
      });
  }, [referralData]);
  //been here is the reward status, I just do not want to manipulate the original variable names in assetsTable
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.ReferralContent);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const sortedPartnerPortal = useMemo(() => {
    if (!referralData) return;
    let sorted = referralData.referrals.map((referral) => {
      let user_status;
      let reward_status;
      let reward;
      let code = referral.code;
      let method = referral.method;
      let email_address = referral.customer_email;

      if (referral.reward.time && referral.reward.time !== null) {
        reward = `${Math.round(referral.reward.time / 2629746000)} ${
          dublicatedcontent.dublicatedText85
        }`;
      }

      if (referral.reward.money && referral.reward.money !== null) {
        reward = `${referral.reward.money} dollars`;
      }
      if (
        referral.reward.money &&
        referral.reward.money !== null &&
        referral.reward.time &&
        referral.reward.time !== null
      ) {
        reward = `${Math.round(referral.reward.time / 2629746000)} ${
          dublicatedcontent.dublicatedText85
        } & ${referral.reward.money} dollars`;
      }

      if (referral.status.customer_status === "invitation")
        user_status = dublicatedcontent.dublicatedText86;
      else if (referral.status.customer_status === "trial")
        user_status = dublicatedcontent.dublicatedText87;
      else if (referral.status.customer_status === "subscription")
        user_status = dublicatedcontent.dublicatedText88;
      else if (referral.status.customer_status === "cancelation")
        user_status = dublicatedcontent.dublicatedText89;
      else user_status = dublicatedcontent.dublicatedText86;

      if (referral.reward_status === "done")
        reward_status = `${dublicatedcontent.dublicatedText90}!`;
      else if (referral.reward_status === "none")
        reward_status = dublicatedcontent.dublicatedText91;
      else reward_status = dublicatedcontent.dublicatedText91;

      if (referral.reward_status === "done" && referral.reward?.money) {
        reward_status = `${dublicatedcontent.dublicatedText230}`;
      }

      if (referral.code === "bonus" || referral.code === "BONUS") {
        code = `${dublicatedcontent.dublicatedText231}`;
        email_address = `${dublicatedcontent.dublicatedText231}`;
        method = `${dublicatedcontent.dublicatedText231}`;
        user_status = null;
      }

      return {
        date: dayjs(referral.date).format("YYYY-MM-DD"),
        email_address,
        user_status,
        can_resend: referral.status.can_resend,
        reward_status,
        reward,
        code,
        method,
        id: referral.id,
      };
    });
    if (referral) {
      sorted = sorted.filter((item) => item.user_status === referral);
    }

    if (ben) {
      sorted = sorted.filter((item) => item.reward_status === ben);
    }

    return sorted;
  }, [
    data,
    referral,
    ben,
    websiteCurrentLang,
    content,
    dublicatedcontent,
    referralData,
  ]);

  const partnerPortalColumns = [
    {
      Header: content.tableHeader1,
      accessor: "date",
      disableSortBy: true,
    },
    {
      Header: dublicatedcontent.dublicatedText74,
      accessor: "email_address",
    },
    {
      Header: content.tableHeader3,
      accessor: "user_status",
    },
    {
      Header: content.tableHeader4,
      accessor: "reward",
      disableSortBy: true,
    },
    {
      Header: content.tableHeader5,
      accessor: "reward_status",
    },
    {
      Header: content.tableHeader6,
      accessor: "code",
    },
    {
      Header: content.tableHeader6,
      accessor: "method",
    },
  ];

  return (
    <>
      {contextHolder}
      <PendingModal open={pendingModal} onCancel={onCancelPendingModal} />

      <ActivateYourAccount
        open={openValidateAccountPopup}
        onOk={onOkValidateAccount}
        onCancel={onCancelValidateAccount}
      />
      {reward.total_unclaimed > 0 && (
        <ClaimRewards
          open={openClaimRewardPopup}
          onOk={onOkClaimReward}
          onCancel={onCancelClaimReward}
          reward={reward.total_unclaimed}
          userData={userData}
        />
      )}
      <div className={styles.section1}>
        {/* first section */}

        {width > 835 && (
          <div className={styles.titleWrapper}>
            <p style={{}} className={styles.section1Title}>
              {dublicatedcontent?.dublicatedText105}
            </p>
            {validated === "false" ? (
              <p
                style={{
                  color: "#0091EA",
                  fontWeight: 400,
                  fontSize: "14px",
                  textDecoration: "underline",
                  cursor: "pointer",
                  margin: 0,
                  marginTop: "2px",
                }}
                onClick={(e) => {
                  setOpenValidateAccountPopup(true);
                }}
              >
                {dublicatedcontent.dublicatedText106}
              </p>
            ) : validated === "pending" ? (
              <p
                style={{
                  color: "#0091EA",
                  fontWeight: 400,
                  fontSize: "12px",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  setPendingModal(true);
                }}
              >
                {dublicatedcontent.dublicatedText107}
              </p>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <OkSvg
                  style={{
                    marginBottom: "2px",
                  }}
                />
                <p
                  style={{
                    color: "#419F23",
                    fontWeight: 400,
                    fontSize: "12px",
                    margin: 0,
                  }}
                >
                  {dublicatedcontent.dublicatedText108}
                </p>
              </div>
            )}

            <div></div>
          </div>
        )}
      </div>
      {width > 835 && <div className={styles.rect} />}

      {/* second section */}

      <div className={styles.section2}>
        <p
          className={styles.section2Title1}
          style={
            UserData().userValidationData.customer_reward_type === "time" ||
            UserData().userValidationData.customer_reward_type === "time"
              ? {}
              : {
                  marginBottom: "0",
                }
          }
        >
          {(UserData().userValidationData.partner_reward_type === "money" ||
            UserData().userValidationData.partner_reward_type === "time") &&
            dublicatedcontent.dublicatedText109}

          {UserData().userValidationData.partner_reward_type === "money" &&
            /*
              Currency leads in English ("$10") and trails in French ("10 €").
              Both slots read !isFrench here, which printed the symbol twice in
              English and not at all in French. PartnerPortalContent, which this
              file was copied from, has it the right way round.
            */
            ` ${!isFrench ? currency : ""}${
              UserData().userValidationData.partner_reward_money
            }${isFrench ? currency : ""} `}

          {UserData().userValidationData.partner_reward_type === "time" &&
            ` ${Math.round(
              UserData().userValidationData.partner_reward_time / 2629746000
            )} ${dublicatedcontent.dublicatedText254} `}

          {(UserData().userValidationData.partner_reward_type === "money" ||
            UserData().userValidationData.partner_reward_type === "time") &&
            dublicatedcontent.dublicatedText110}
        </p>

        <p className={styles.section2Title2}>
          {(UserData().userValidationData.customer_reward_type === "money" ||
            UserData().userValidationData.customer_reward_type ===
              "percentage" ||
            UserData().userValidationData.customer_reward_type === "time") &&
            (UserData().userValidationData.partner_reward_type === "money" ||
              UserData().userValidationData.partner_reward_type === "time") &&
            dublicatedcontent.dublicatedText111}

          {(UserData().userValidationData.customer_reward_type === "money" ||
            UserData().userValidationData.customer_reward_type ===
              "percentage" ||
            UserData().userValidationData.customer_reward_type === "time") &&
            UserData().userValidationData.partner_reward_type !== "money" &&
            UserData().userValidationData.partner_reward_type !== "time" &&
            dublicatedcontent.dublicatedText255}
          {UserData().userValidationData.customer_reward_type === "money" &&
            ` ${!isFrench ? currency : ""}${
              UserData().userValidationData.customer_reward_amount
            }${isFrench ? currency : ""} `}

          {UserData().userValidationData.customer_reward_type ===
            "percentage" &&
            ` ${UserData().userValidationData.customer_reward_percentage}% ${
              dublicatedcontent.discount
            }!`}
          {UserData().userValidationData.customer_reward_type === "time" &&
            ` ${Math.round(
              UserData().userValidationData.customer_reward_time / 2629746000
            )} ${dublicatedcontent.months}`}
          {UserData().userValidationData.customer_reward_type === "time" &&
            dublicatedcontent.dublicatedText112}
        </p>
        <p className={styles.section2Text}>
          {dublicatedcontent.dublicatedText113}
          <br />
          {UserData().userValidationData.has_bonus &&
            `${dublicatedcontent.dublicatedText114} ${
              UserData().userValidationData.bonus_customers
            } ${dublicatedcontent.dublicatedText115}
                 ${UserData().userValidationData.bonus_money} ${
              dublicatedcontent.dublicatedText116
            }`}
        </p>
        <p className={styles.section2Text}>
          {content.referralSection2termsFirstPart}&nbsp;
          <a
            href={`${window?.location?.protocol}//${window?.location?.host}/user/terms-and-conditions`}
            target="_blank"
            rel="noreferrer"
            className={styles.terms}
          >
            {content.referralSection2termsSecondPart}
          </a>
        </p>
      </div>
      <div className={styles.rect} />

      {/* third section */}

      <div className={styles.section3}>
        <div className="section3Wrapper">
          {width > 800 && (
            <Skeleton loading={skeletonLoading}>
              <div className="section3Wrapper_col1">
                <p className="section3Wrapper_col1_title">
                  {dublicatedcontent.dublicatedText117}
                </p>
                {totalEarned > 0 ? (
                  <p
                    className="section3Wrapper_col1_title"
                    style={{ color: "#419F23" }}
                  >
                    {!isFrench && currency}
                    {totalEarned} {isFrench && currency}
                  </p>
                ) : (
                  <p
                    className="section3Wrapper_col1_title"
                    style={{ color: "#419F23" }}
                  >
                    {!isFrench && currency}0 {isFrench && currency}
                  </p>
                )}
                {reward?.total_earned?.time > 0 && (
                  <p
                    className="section3Wrapper_col1_title"
                    style={{ color: "#419F23" }}
                  >
                    {Math.round(reward.total_earned.time / 2629746000)}
                    {dublicatedcontent.dublicatedText118}
                  </p>
                )}
              </div>
              <div className="section3Wrapper_col2">
                <p className="section3Wrapper_col1_title">
                  {dublicatedcontent.dublicatedText119}
                </p>
                {reward?.bonus?.bonus_reward?.money && (
                  <p
                    className="section3Wrapper_col1_title"
                    style={{ color: "#419F23" }}
                  >
                    {!isFrench && currency}
                    {reward?.bonus?.total_earned} {isFrench && currency}
                  </p>
                )}

                {reward?.bonus?.bonus_reward?.time && (
                  <p
                    className="section3Wrapper_col1_title"
                    style={{ color: "#419F23" }}
                  >
                    {reward?.bonus?.total_earned}{" "}
                    {dublicatedcontent.dublicatedText118}
                  </p>
                )}
                <p
                  style={{
                    margin: " 0 auto",
                    fontWeight: "400",
                  }}
                >
                  {UserData().userValidationData.has_bonus &&
                    `${dublicatedcontent.dublicatedText120} ${
                      UserData().userValidationData.bonus_customers
                    } ${dublicatedcontent.dublicatedText121} ${
                      UserData().userValidationData.bonus_money
                    }
                   ${dublicatedcontent.dublicatedText116}`}

                  {!UserData().userValidationData.has_bonus &&
                    `${dublicatedcontent.dublicatedText122}`}
                </p>
              </div>
              <div className="section3Wrapper_col3">
                <p className="section3Wrapper_col1_title">
                  {dublicatedcontent.dublicatedText123}
                </p>
                <p
                  className="section3Wrapper_col1_title"
                  style={{
                    color: "#0091EA",
                    fontSize: "26px",
                    fontWeight: "600",
                  }}
                >
                  {!isFrench && currency}
                  {reward?.total_unclaimed} {isFrench && currency}
                </p>
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <Button
                    disabled={reward.total_unclaimed > 0 ? false : true}
                    onClick={(e) => {
                      if (reward.total_unclaimed > 0) {
                        if (validated === "false") {
                          setOpenValidateAccountPopup(true);
                          return;
                        } else if (validated === "pending") {
                          setPendingModal(true);
                          return;
                        }
                        setOpenClaimRewardPopup(true);
                      }
                    }}
                    style={
                      reward.total_unclaimed > 0 ? {} : { width: "max-content" }
                    }
                    className="claimRewardsButton"
                  >
                    {dublicatedcontent.dublicatedText124}
                    {/* {reward.total_unclaimed > 0
                    ? dublicatedcontent.dublicatedText124
                    : dublicatedcontent.dublicatedText124} */}
                  </Button>
                  {reward.total_pending > 0 && (
                    <p
                      style={{
                        margin: "0 auto",
                        marginTop: "5px",
                        width: "max-content",
                        color: "rgb(0, 145, 234)",
                      }}
                    >
                      {dublicatedcontent.dublicatedText247}
                      {!isFrench && currency}
                      {reward.total_pending}
                      {!isFrench && currency}
                      {dublicatedcontent.dublicatedText248}
                    </p>
                  )}
                </div>
              </div>
              <div className="section3Wrapper_col4">
                <p className="section3Wrapper_col1_title">
                  {dublicatedcontent.dublicatedText125}
                </p>
                <p
                  className="section3Wrapper_col1_title"
                  style={{ color: "#419F23" }}
                >
                  {reward?.total_converted}
                </p>
                <p
                  style={{
                    margin: " 0 auto",
                    fontWeight: "400",
                  }}
                >
                  {dublicatedcontent.dublicatedText126}
                </p>
              </div>
              <div className="section3Wrapper_col5">
                <p className="section3Wrapper_col1_title">
                  {dublicatedcontent.dublicatedText127}
                </p>
                <p
                  className="section3Wrapper_col1_title"
                  style={{ color: "#419F23" }}
                >
                  {reward?.total_unconverted}
                </p>
                <p
                  style={{
                    margin: " 0 auto",
                    fontWeight: "400",
                  }}
                >
                  {dublicatedcontent.dublicatedText128}
                </p>
              </div>
            </Skeleton>
          )}
          {width < 800 && (
            <div className="section3WrapperMobile">
              <div className="section3Wrapper_col3">
                <p className="section3Wrapper_col1_title">
                  {dublicatedcontent.dublicatedText123}
                </p>
                <p
                  className="section3Wrapper_col1_title"
                  style={{
                    color: "#0091EA",
                    fontSize: "26px",
                    fontWeight: "600",
                  }}
                >
                  {!isFrench && currency}
                  {reward?.total_unclaimed} {isFrench && currency}
                </p>
                <Button
                  disabled={reward.total_unclaimed > 0 ? false : true}
                  onClick={(e) => {
                    if (validated === "false") {
                      setOpenValidateAccountPopup(true);
                      return;
                    } else if (validated === "pending") {
                      setPendingModal(true);
                      return;
                    }
                    setOpenClaimRewardPopup(true);
                  }}
                  className="claimRewardsButton"
                >
                  {dublicatedcontent.dublicatedText124}
                </Button>
                {reward.total_pending > 0 && (
                  <p
                    style={{
                      margin: "0 auto",
                      marginTop: "0",
                      width: "max-content",
                      color: "rgb(0, 145, 234)",
                    }}
                  >
                    {dublicatedcontent.dublicatedText247}
                    {!isFrench && currency}
                    {reward.total_pending}
                    {!isFrench && currency}
                    {dublicatedcontent.dublicatedText248}
                  </p>
                )}
              </div>
              <div className="section3WrapperMobile_row2">
                <div className="section3Wrapper_col1">
                  <p className="section3Wrapper_col1_title">
                    {dublicatedcontent.dublicatedText117}
                  </p>
                  {totalEarned > 0 ? (
                    <p
                      className="section3Wrapper_col1_title"
                      style={{ color: "#419F23" }}
                    >
                      {!isFrench && currency}
                      {totalEarned} {isFrench && currency}
                    </p>
                  ) : (
                    `${!isFrench ? currency : ""}0 ${isFrench ? currency : ""}`
                  )}
                  {reward?.total_earned?.time > 0 && (
                    <p
                      className="section3Wrapper_col1_title"
                      style={{ color: "#419F23" }}
                    >
                      {Math.round(reward.total_earned.time / 2629746000)}
                      {dublicatedcontent.dublicatedText118}
                    </p>
                  )}
                </div>
                <div className="section3Wrapper_col2">
                  <p className="section3Wrapper_col1_title">
                    {dublicatedcontent.dublicatedText119}
                  </p>
                  {reward?.bonus?.bonus_reward?.money && (
                    <p
                      className="section3Wrapper_col1_title"
                      style={{ color: "#419F23" }}
                    >
                      {!isFrench && currency}
                      {reward?.bonus?.total_earned} {isFrench && currency}
                    </p>
                  )}{" "}
                  {reward?.bonus?.bonus_reward?.time && (
                    <p
                      className="section3Wrapper_col1_title"
                      style={{ color: "#419F23" }}
                    >
                      {reward?.bonus?.total_earned}{" "}
                      {dublicatedcontent.dublicatedText118}
                    </p>
                  )}
                  <p
                    style={{
                      margin: " 0 auto",
                      fontWeight: "400",
                    }}
                  >
                    {UserData().userValidationData.has_bonus &&
                      `${dublicatedcontent.dublicatedText120} ${
                        UserData().userValidationData.bonus_customers
                      } ${dublicatedcontent.dublicatedText121} ${
                        UserData().userValidationData.bonus_money
                      }
                   ${dublicatedcontent.dublicatedText116}`}

                    {!UserData().userValidationData.has_bonus &&
                      dublicatedcontent.dublicatedText122}
                  </p>
                </div>
              </div>
              <div className="section3WrapperMobile_row3">
                <div className="section3Wrapper_col4">
                  <p className="section3Wrapper_col1_title">
                    {dublicatedcontent.dublicatedText125}
                  </p>
                  <p
                    className="section3Wrapper_col1_title"
                    style={{ color: "#419F23" }}
                  >
                    {reward?.total_converted}
                  </p>
                  <p
                    style={{
                      margin: " 0 auto",
                      fontWeight: "400",
                    }}
                  >
                    {dublicatedcontent.dublicatedText126}
                  </p>
                </div>
                <div className="section3Wrapper_col5">
                  <p className="section3Wrapper_col1_title">
                    {dublicatedcontent.dublicatedText127}
                  </p>
                  <p
                    className="section3Wrapper_col1_title"
                    style={{ color: "#419F23" }}
                  >
                    {reward?.total_unconverted}
                  </p>
                  <p
                    style={{
                      margin: " 0 auto",
                      fontWeight: "400",
                    }}
                  >
                    {dublicatedcontent.dublicatedText128}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {width > 800 && <div className={styles.rect} />}

      {/* new referral code */}
      {/*
        The invite block moved to the My Customers tab (User/My Customers). It is
        the same ReferralCodesSection, mounted there instead of here.
      */}
      {/* campagin section */}
      {campaginNumber
        .filter((code) => code.master === false)
        .map((data, i) => {
          let canBeDeleted = false;

          if (savedCampagins.length <= 1) {
            canBeDeleted = false;
          } else if (savedCampagins.length > 1) {
            canBeDeleted = true;
          }

          if (data.newCampaign === true) {
            canBeDeleted = true;
          }
          return (
            <CampaignSection
              setSavedCampagins={setSavedCampagins}
              allCampaigns={campaginNumber}
              setCampaginNumber={setCampaginNumber}
              data={data}
              canBeDeleted={canBeDeleted}
              key={i}
              setCodeDeleted={setCodeDeleted}
              setReferralData={setReferralData}
            />
          );
        })}
      {!loadingCamp &&
        campaginNumber.filter((code) => code.master === false).length === 0 && (
          <div
            className="addTotallyNewCampain"
            onClick={(e) => {
              setCampaginNumber((prev) => {
                return [
                  ...prev,
                  {
                    master: false,
                    code: null,
                    id: Math.random().toFixed(3),
                    newCampaign: true,
                    url: `${window?.location?.protocol}//${window?.location?.host}/register/?referral=`,
                  },
                ];
              });
            }}
          >
            <p className={styles.section3Text1}>
              {dublicatedcontent.dublicatedText262}
            </p>
            <div className="addNewCampaign">
              <PlusCircleOutlined
                style={{
                  fontSize: "14px",
                }}
              />
              <p
                style={{
                  margin: "0",
                }}
              >
                {dublicatedcontent.dublicatedText263}
              </p>
            </div>
          </div>
        )}
      {!loadingCamp &&
        campaginNumber.filter((code) => code.master === false).length < 3 &&
        campaginNumber.filter((code) => code.master === false).length >= 1 && (
          <div
            className="addAnotherCampain"
            onClick={(e) => {
              setCampaginNumber((prev) => {
                return [
                  ...prev,
                  {
                    code: null,
                    master: false,
                    id: Math.random().toFixed(3),
                    newCampaign: true,
                    url: `${window?.location?.protocol}//${window?.location?.host}/register/?referral=YOUR CODE`,
                  },
                ];
              });
            }}
          >
            <PlusCircleOutlined
              style={{
                fontSize: "14px",
              }}
            />
            <p
              style={{
                margin: "0",
              }}
            >
              {dublicatedcontent.dublicatedText129}
            </p>
          </div>
        )}
      <div className={styles.rect} />
      {/* fourth section */}

      <div className={styles.section4}>
        <p className={styles.section4Text1}>{content.referralSection3Text4}</p>
        <div className={styles.table_div}>
          <TableFilter
            component={"referral"}
            filter={filter}
            setFilter={setFilter}
            setAsset={setReferral}
            setBen={setBen}
          />
          {sortedPartnerPortal && (
            <ReferralTable
              columns={partnerPortalColumns}
              data={sortedPartnerPortal}
              filter={filter}
              setFilter={setFilter}
              // assetsLength={userData.UserData.assets}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default PartnerPortalContent;
